/* Never use the storefront country (US for unsupported visitors) or a URL country alone as guarantee evidence. */
(function () {
  'use strict';
  var root = document.documentElement;
  root.removeAttribute('data-tx-guarantee-confirmed');
  var configNode = document.getElementById('tx-guarantee-context');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  var allowed = String(config.countries || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  function eligible(country) {
    return typeof country === 'string' && /^[A-Z]{2}$/.test(country) && allowed.indexOf(country) !== -1;
  }
  if (!eligible(config.selected)) return;
  var expired = false;
  var timer = setTimeout(function () { expired = true; }, 5000);
  var path = String(config.root || '/').replace(/\/?$/, '/');
  fetch(path + 'browsing_context_suggestions.json?country[enabled]=true', {
    credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
  }).then(function (response) {
    if (!response.ok) throw new Error('Country detection unavailable');
    return response.json();
  }).then(function (data) {
    var detected = data && data.detected_values && data.detected_values.country;
    if (!expired && detected && eligible(detected.handle)) {
      root.setAttribute('data-tx-guarantee-confirmed', 'true');
    }
  }).catch(function () {
    /* Failure, missing detection and no JavaScript all leave claims hidden. */
  }).finally(function () { clearTimeout(timer); });
})();
